// preorder-cart-validation.js
// Validation panier : bloque les paniers mixtes précommande / disponible
// Détection via tag "preorder" sur les produits
// Neofid Studios — août 2026

(function () {

  const MESSAGES = {
    mixed: {
      fr: "⚠️ Les précommandes ne peuvent pas être combinées avec des articles disponibles immédiatement. Veuillez passer deux commandes séparées.",
      en: "⚠️ Pre-orders cannot be combined with immediately available items. Please place two separate orders.",
    },
    multiPreorder: {
      fr: "⚠️ Vous ne pouvez commander qu'un seul article en précommande à la fois, car les dates de livraison peuvent différer. Veuillez passer des commandes séparées.",
      en: "⚠️ You can only order one pre-order item at a time, as delivery dates may differ. Please place separate orders.",
    },
  };

  function isPreorder(item) {
    // Détection via le tag "preorder" retourné par /cart.js
    return item.product_tags && item.product_tags.split(', ').includes('preorder');
  }

  function validateCart(cartItems) {
    const preorderItems = cartItems.filter(isPreorder);
    const regularItems  = cartItems.filter(item => !isPreorder(item));

    // Règle 1 : mélange précommande + article disponible
    if (preorderItems.length > 0 && regularItems.length > 0) {
      return MESSAGES.mixed;
    }

    // Règle 2 : plusieurs précommandes (même produit ou produits différents)
    if (preorderItems.length > 1) {
      return MESSAGES.multiPreorder;
    }

    return null; // panier valide
  }

  function showError(message, anchor) {
    let errorEl = document.getElementById('preorder-validation-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.id = 'preorder-validation-error';
      errorEl.style.cssText = `
        background:#fff3cd;
        border:1px solid #ffc107;
        border-radius:6px;
        padding:12px 16px;
        margin:12px 0;
        font-size:14px;
        line-height:1.5;
        color:#333;
      `;
      const target = anchor
        || document.querySelector('form[action="/cart"]')
        || document.querySelector('main');
      target?.prepend(errorEl);
    }
    errorEl.innerHTML = `
      <strong>${message.fr}</strong><br>
      <em style="color:#666">${message.en}</em>
    `;
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError() {
    document.getElementById('preorder-validation-error')?.remove();
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // Interception du bouton checkout
  function interceptCheckout() {
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest(
        '[name="checkout"], [href="/checkout"], button[type="submit"][name="checkout"]'
      );
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const cart  = await fetchCart();
      const error = validateCart(cart.items);

      if (error) {
        showError(error, btn.closest('form') ?? btn.parentElement);
      } else {
        clearError();
        if (btn.form) {
          btn.form.submit();
        } else {
          window.location.href = '/checkout';
        }
      }
    }, true);
  }

  // Validation en temps réel (thèmes Ajax)
  async function onCartUpdate() {
    const cart = await fetchCart();
    if (cart.items.length === 0) { clearError(); return; }
    const error = validateCart(cart.items);
    error ? showError(error) : clearError();
  }

  document.addEventListener('cart:updated', onCartUpdate);
  document.addEventListener('cart:refresh', onCartUpdate);

  document.addEventListener('DOMContentLoaded', function () {
    interceptCheckout();
    if (window.location.pathname === '/cart') {
      onCartUpdate();
    }
  });

})();
